export const INFINITE_SCROLL_QUERY_THRESHOLD = 85;
export const MAX_MODAL_WIDTH = '552px';
export const DEFAULT_BOTTOM_SHEET_HEIGHT = 700;

/**
 * Height the drag handle adds to a native sheet when `closeOnDragDown` is set: the 5px bar
 * react-native-raw-bottom-sheet renders plus its 10px margin, top and bottom. The handle sits in
 * the layout flow above the content, so the sheet height has to make room for it.
 */
export const DRAG_HANDLE_HEIGHT = 25;

export const CONTENT_TEST_ID = 'scrollable-modal-content';
export const FOOTER_TEST_ID = 'scrollable-modal-footer';
export const HEADER_TEST_ID = 'scrollable-modal-header';

/** Heading size the sheet title renders at. */
export const TITLE_HEADING_SIZE = '300';

/**
 * Heading height assumed for the frame before `onLayout` reports the real one: one line of the
 * native `heading.300` line height, two for a title long enough to wrap. Not read from the theme
 * because the shared `useTheme` type resolves to the web theme, whose `lineHeight` is a unitless
 * ratio rather than the native pixel value. The heading scales with the device font scale, so
 * this is only a first pass, replaced as soon as it is measured.
 */
export const ESTIMATED_TITLE_HEIGHT = 25;
export const ESTIMATED_LONG_TITLE_HEIGHT = 50;

/** Spacing tokens BottomSheet puts around the header row (`mt` and `mb` on the header Flex). */
export const HEADER_MARGIN_TOP = '6x';
export const HEADER_MARGIN_BOTTOM = '4x';

/**
 * Geometry of the dismiss-icon column BottomSheet renders beside the heading: `p="4x"` above the
 * icon, which carries `mb="5x"`. It shares a centered flex row with the heading, so whichever of
 * the two is taller sets the row height.
 */
export const DISMISS_BUTTON_PADDING_TOP = '4x';
export const DISMISS_BUTTON_ICON_MARGIN_BOTTOM = '5x';
export const DISMISS_BUTTON_ICON_SIZE = 16;
